module.exports = __webpack_public_path__ + "img/video.8528ddf2.webp";